export default __webpack_public_path__ + "static/ShareSection3_es-da205cafb8720f0d00262cf6cd565d1f.png";